// This is what the height of the content of the L0 buttons ends up being after accounting for
// font-size and line-height. Not sure if there's a better way to dynamically define this. Edit this
// value if you need to adjust the height of a nav item for CLS!
//
// Last Updated: 8/17/2025
const CATEGORY_CONTENT_HEIGHT = '40px';

const PrimaryCategoriesNoContent = () => {
  return (
    <span data-testid="PrimaryCategoriesNoContent" style={{ height: CATEGORY_CONTENT_HEIGHT }} />
  );
};

export default PrimaryCategoriesNoContent;
